import React, { Component, Fragment } from "react";
import { Switch, Route, Redirect, Link } from "react-router-dom";
//import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

import AuthService from "../Autenticacao/services/auth.service";

import Login from "../Login/login.component";
import Register from "../Login/register.component";
import Choice from "../Login/choice.component";
import Home from "../Pages/home.component";
import Profile from "../Pages/profile.component";
import PagePrincipal from '../../../pages/Principal/index'

import EventBus from "../Autenticacao/common/EventBus";

class App extends Component {
  constructor(props) {
    super(props);
    this.logOut = this.logOut.bind(this);

    // Lido já no constructor (não só em componentDidMount) pra que a 1ª
    // renderização já saiba se há usuário logado — senão, num usuário já
    // autenticado em "/login"/"/register", o 1º render mostrava o Login/
    // Register (currentUser ainda undefined) e só no render seguinte
    // (após o setState em componentDidMount) é que o <Redirect> entrava,
    // desmontando o Form do Login/Register — o que expõe um erro não
    // capturado no unmount do react-validation e derruba a árvore React
    // inteira (sem Error Boundary). Lendo aqui, esse form nunca chega a
    // montar quando o usuário já está autenticado.
    const user = AuthService.getCurrentUser();
    this.state = {
      showAdminBoard: user ? user.roles.includes("ROLE_ADMIN") : false,
      currentUser: user || undefined,
    };
  }

  componentDidMount() {
    EventBus.on("logout", () => {
      this.logOut();
    });
  }

  componentWillUnmount() {
    EventBus.remove("logout");
  }

  logOut() {
    AuthService.logout();
    this.setState({
      showAdminBoard: false,
      currentUser: undefined,
    });
  }

  render() {
    const { currentUser, showAdminBoard } = this.state;

    return (
      <div>

        {currentUser ? (

          <PagePrincipal />

        ) : (

          <Fragment>
            <nav className="navbar navbar-expand navbar-dark bg-dark nav-login">
              <a href={"http://sigem.observatoriopb.com.br"} className="navbar-brand">
                SENAI
              </a>
              <div className="navbar-nav mr-auto">

                {showAdminBoard && (
                  <li className="nav-item">
                    <Link to={"/admin"} className="nav-link">
                      Admin Board
                    </Link>
                  </li>
                )}

                {currentUser && (
                  <li className="nav-item">
                    <Link to={"/user"} className="nav-link">
                      User
                    </Link>
                  </li>
                )}
              </div>

              {currentUser ? (
                <div className="navbar-nav ml-auto">
                  <li className="nav-item">
                    <Link to={"/profile"} className="nav-link">
                      {currentUser.username}
                    </Link>
                  </li>
                  <li className="nav-item">
                    <a href="/login" className="nav-link" onClick={this.logOut}>
                      LogOut
                    </a>
                  </li>
                </div>
              ) : (
                window.location.pathname === '/' ? 
                  null 
                  :
                  (<div className="navbar-nav ml-auto">
                    <li className="nav-item">
                      <Link to={"/login"} className="nav-link">
                        Login
                      </Link>
                    </li>

                    <li className="nav-item">
                      <Link to={"/register"} className="nav-link">
                        Cadastro
                      </Link>
                    </li>
                  </div>)
              )}
            </nav>
            <div className="col-md-6 ml-auto mr-auto text-center">
              <h4 className="card-title">
                Módulo de Metas 2027
                <p className="category">Sistema de Gerenciamento de Metas - SIGEM</p>
              </h4>
            </div>
          </Fragment>

        )}

        {/* currentUser autenticado navegando pra "/", "/login" ou "/register" (voltar
        do navegador, favorito, URL digitada) precisa ser redirecionado — sem isso o
        <PagePrincipal/> acima e o Login/Register aqui renderizavam ao mesmo tempo,
        um dentro do outro, produzindo uma tela quebrada e inutilizável. */}
        <Switch>
          {/*<Route exact path={["/", "/home"]} component={Home} />*/}
          <Route exact path="/" render={(routeProps) => (currentUser ? <Redirect to="/dashboard" /> : <Login {...routeProps} />)} />
          <Route exact path="/login" render={(routeProps) => (currentUser ? <Redirect to="/dashboard" /> : <Login {...routeProps} />)} />
          <Route exact path="/register" render={(routeProps) => (currentUser ? <Redirect to="/dashboard" /> : <Register {...routeProps} />)} />
        </Switch>

      </div>
    );
  }
}

export default App;
